import { FormPage } from 'components/page';
import { useLoaderContext } from 'context/LoaderContext';
import { ConfiguracaoGeralGeneralBlock } from 'pages/revendedor/configuracao-geral/components';
import { useMutateConfiguracaoGeral } from 'pages/revendedor/configuracao-geral/hooks';

export function ConfiguracaoGeralFormComp() {
    const { handleSubmit, isLoading } = useMutateConfiguracaoGeral();

    useLoaderContext(isLoading);

    return (
        <FormPage
            goBackButton
            keepOriginalTitle
            title="Configurações Gerais"
            url="/gestao/revendedordesconto/ativo"
            values={{}}
            queryWithId={false}
            onSubmit={handleSubmit}
        >
            <ConfiguracaoGeralGeneralBlock />
        </FormPage>
    );
}
